<template>
  <div class="is-main-content">
    <div class="columns">
      <div class="column ">
        <div>
          <div class="container is-fluid">
            <div class="columns">
              <div class="column is-9-fullhd is-7-desktop is-6-tablet">
                <div class="content">
                  <h3 class="level">Mes clients / prospects</h3>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <br>
          <div class="container is-fluid">
            <app-liste />
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import Liste from './liste';

const Clients = createNamespacedHelpers('clients');

export default {
  name: 'page',
  components: {
    appListe: Liste,
  },
  computed: {
    ...Clients.mapGetters({
      clients: 'clients',
    }),
  },
  methods: {
    ...Clients.mapActions({
      actionsPrechargementClients: 'prechargementClients',
    }),
  },
  mounted() {
    if (!this.clients) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsPrechargementClients().then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Echec du chargement des clients', e);
      });
    }
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/clientProspect/recherche/index.vue